<template>
  <div :class="{ 'nav-button-container': props.mode === 'tile' }">
    <v-btn
      v-for="item in visibleMenuItems"
      :key="item.title"
      :to="item.route"
      :color="props.mode === 'tile' ? 'primary' : undefined"
      :class="{ 'mb-4': props.mode === 'tile' }"
      :block="props.mode === 'tile'"
      :height="props.mode === 'tile' ? 150 : undefined"
      :variant="props.mode === 'normal' ? 'text' : 'elevated'"
    >
      <v-icon :size="props.mode === 'tile' ? 36 : 24" :start="true">
        {{ item.icon }}
      </v-icon>
      {{ $t(item.title) }}
    </v-btn>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue'
import { useAuthStore} from '@/store/auth'

const props = defineProps({
  mode: {
    type: String,
    default: 'normal',
    validator: (value) => ['normal', 'tile'].includes(value)
  }
})

const authStore = useAuthStore()

const menuItems = [
  {title: 'nav.userManagement', icon: 'mdi-account-group', route: '/users', adminOnly: true},
  {title: 'nav.metaManagement', icon: 'mdi-database', route: '/meta', adminOnly: true},
  {title: 'nav.licenseManagement', icon: 'mdi-license', route: '/licenses', adminOnly: false},
]

const visibleMenuItems = computed(() =>
    menuItems.filter(item => !item.adminOnly || authStore.isAdmin)
)
</script>

<style scoped>
.nav-button-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.v-btn {
  text-transform: none;
}
</style>